import get from 'lodash.get';

const getTemplates = (rootState) => get(rootState, 'templates.data.results', []);

export default getTemplates;
